// extracted by mini-css-extract-plugin
export default {"button":"LineButton_button__tm2h5"};